import { _eventBus } from "../../../../core/events/EventBus";
import { StepDefinition } from "../../../../core/flows/StepDefinition";
import { StepFlow } from "../../../../core/flows/StepFlow";
import { myAccountTree } from "../../../../Orchestrator/ConstantTree";
import { getPaymentCardsAction } from "../../../../Actions/LogicActions/MyAccount/Payments/GetPaymentCardsAction";
import { deletePaymentCardAction } from "../../../../Actions/LogicActions/MyAccount/Payments/DeletePaymentCardAction";
import { getRecoilStateValue } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { IUserResponse } from "../../../../Orchestrator/Types/Interface/IUser";
import { IDeletePaymentCardActionParams } from "../../../../Orchestrator/Types/Interface/ActionParams/PaymentCardsActionParams";
import { fetchVouchersAction } from "../../../../Actions/LogicActions/Voucher/FetchVouchersAction";
import { IAddVoucherActionParams, IFetchVoucherDetailActionParams, IFetchVouchersActionParams } from "../../../../Orchestrator/Types/Interface/ActionParams/VoucherActionParams";
import { fetchVoucherDetailAction, FetchVoucherDetailAction } from "../../../../Actions/LogicActions/Voucher/FetchVoucherDetailAction";
import { addVoucherAction } from "../../../../Actions/LogicActions/Voucher/AddVoucherAction";

export class PaymentsInitStep extends StepFlow {
  get stepName() { return "MyAccountPaymentsInit_Step"; }

  async onEventSetup(): Promise<void> {
    this.registerEventSubscription(
      _eventBus.on({
        eventName: myAccountTree.paymentCards.Get,
        handler: async () => {
          const userData = getRecoilStateValue<IUserResponse>("userDataAtom");
          if (userData?.userId) {
            getPaymentCardsAction.setParams({ userId: userData.userId })
            await getPaymentCardsAction.execute();
          }
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<IDeletePaymentCardActionParams, void>({
        eventName: myAccountTree.paymentCards.Delete,
        handler: async (payload) => {
          const { userId, paymentCardId } = payload.data!;
          if (userId && paymentCardId) {
            deletePaymentCardAction.setParams({ userId, paymentCardId });
            await deletePaymentCardAction.execute();
          }
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on({
        eventName: myAccountTree.paymentCards.Vouchers.Get,
        handler: async () => {
          const userData = getRecoilStateValue<IUserResponse>("userDataAtom");
          if (userData?.id) {
            const params: IFetchVouchersActionParams = {
              userId: userData.id
            }
            fetchVouchersAction.setParams(params)
            await fetchVouchersAction.execute()
          }
        }
      })
    )

    this.registerEventSubscription(
      _eventBus.on<IFetchVoucherDetailActionParams, void>({
        eventName: myAccountTree.paymentCards.Vouchers.Details,
        handler: async (payload) => {
          const { userId, voucherId } = payload.data!;
          fetchVoucherDetailAction.setParams({ userId, voucherId })
          await fetchVoucherDetailAction.execute()
        }
      })
    )

    this.registerEventSubscription(
      _eventBus.on<IAddVoucherActionParams, void>({
        eventName: myAccountTree.paymentCards.Vouchers.Add,
        handler: async (payload) => {
          const { userId, voucherCode } = payload.data!;
          addVoucherAction.setParams({ userId, voucherCode })
          await addVoucherAction.execute()
        }
      })
    )

    this.registerEventSubscription(
      _eventBus.on({
        eventName: myAccountTree.exitStep,
        handler: () => {
          this.next();
        }
      })
    )

  }

  async onExecute(): Promise<void> {
    console.log("My Account - Payments Page Initialize.....");
    _eventBus.emit({
      eventName: myAccountTree.paymentCards.Get,
    });
  }
}

export const PaymentsInitStepDeclaration = new StepDefinition({
  stepName: "MyAccountPaymentsInit_Step",
  stepClass: PaymentsInitStep,
})